import { FC, MouseEvent, useState } from "react";

import { MoreHoriz } from "@livechat/design-system-icons";
import { ActionMenu, Button, IActionMenuOption, Icon } from "@livechat/design-system-react-components";

type FormContextMenuProps = {
  disabled: boolean;
  options: IActionMenuOption[];
  id?: string;
};

export const FormContextMenu: FC<FormContextMenuProps> = ({ disabled, options, id }) => {
  const [toggled, setToggled] = useState(false);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function handleClick(e: MouseEvent<HTMLElement>) {
    e.stopPropagation();
    setToggled(true);
  }

  return (
    <ActionMenu
      visible={toggled}
      onClose={() => setToggled(false)}
      options={options}
      triggerRenderer={
        <Button
          kind="plain"
          onClick={handleClick}
          disabled={disabled}
          icon={<Icon source={MoreHoriz} />}
          data-testid={`context-menu-trigger-${id}`}
        />
      }
    />
  );
};
